<template>
    <div class="container-fluid thankyou-fancy">
        <div class="content text-center p-5">
            <img src="@/assets/images/exclamation-triangle.png" alt="Símbolo de advertencia"/>
            <h1>Correo duplicado.</h1>
            <p>Este correo fue agregado anteriormente.</p>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.thankyou-fancy {
    margin-top: 2em;
    margin-bottom: 2em;
    position: relative;
    border-radius: 1em;

    .content {
        h1 {
            font-size: $large-font-size;
            font-family: $primary-font;
            color: $orange-dark-color;
            margin-top: 37px;
        }

        p {
            font-size: 20px;
        }
    }
}
</style>

<script>
export default {
    props: {
        backToSignUp: {
            type:Boolean,
        }
    },
    mounted() {
        setTimeout(() => {
            this.$modal.hide('sign-up-modal');
            if (this.backToSignUp) {
                this.$modal.show('sign-up-modal');
            }
        }, 2000);
    }
}
</script>